import React from 'react'
import PropTypes from 'prop-types'
import { TEST_LIBRARY_TABS } from '../../utils/pdlBulkUploadHandoff'
import { StyledTabs, TabPane } from './styled'

const TestLibraryTabs = ({ activeTab, onChange, myContentTabLabel }) => (
  <StyledTabs activeKey={activeTab} onChange={onChange}>
    <TabPane
      tab={<span data-cy="testLibraryTabMyContent">{myContentTabLabel}</span>}
      key={TEST_LIBRARY_TABS.MY_CONTENT}
    />
    <TabPane
      tab={
        <span data-cy="testLibraryTabReadyToReview">
          Pending Review (Imported)
        </span>
      }
      key={TEST_LIBRARY_TABS.READY_TO_REVIEW}
    />
  </StyledTabs>
)

TestLibraryTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  myContentTabLabel: PropTypes.string,
}

TestLibraryTabs.defaultProps = {
  myContentTabLabel: 'Created by me',
}

export default TestLibraryTabs
